/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";

//import images
import sentImage from "assets/HomeAssets/Images/sent.png";

const SentModal = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  return (
    <div className="signin_modal job_modal sucess_modal">
      <div className="modal fade show" id="sent_mdl">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>

            <div className="modal-body">
              <div className="login_body">
                <div className="success_mdlpic">
                  <img src={sentImage} alt="" />
                </div>
                <div className="congrats_text">
                  <h3>{t("Thanks")}</h3>
                  <h5>{t("We will get back to you soon.")}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SentModal;
